import gsap from 'gsap';

const ImageInitial = (element) => {
  gsap.set(element.querySelector('.image__picture-actual'), { scale: 1.5 });
};

export default ImageInitial;
